import { Link } from "@amzn/awsui-components-react";
import { useContext } from "react";
import {
  createFRKConsoleLink,
  createRoyaltyTraceLink,
} from "../../helpers/linkUtils";
import { OrderIdContext, StageContext } from "../../contexes/OrderIdContext";
import { DIGITAL_ORDER_SOURCES } from "../../constants";
import { AccountingEvent } from "../../types/events";
import { DigitalBusinessDocument } from "../../types/documents";
import { isDigitalBusinessDocument } from "../../helpers/typeChecks";

interface DigitalOrderSourceLinkProps {
  source?: string;
  event: AccountingEvent | DigitalBusinessDocument;
}

const DEFAULT_SOURCE = DIGITAL_ORDER_SOURCES.FOIL;

function getVersionFromEvent(
  event: AccountingEvent | DigitalBusinessDocument
): number | undefined {
  if (isDigitalBusinessDocument(event)) {
    return event.body?.metadata?.events?.AccountingRecord?.version;
  }

  return event.sourceEventsToVersion?.AccountingRecord || undefined;
}

export default function DigitalOrderSourceLink({
  source = DEFAULT_SOURCE,
  event,
}: DigitalOrderSourceLinkProps) {
  const orderId = useContext(OrderIdContext);
  const stage = useContext(StageContext);

  const normalizedSource = source.toUpperCase();

  const version = getVersionFromEvent(event);

  const href =
    normalizedSource === DIGITAL_ORDER_SOURCES.ARK
      ? createFRKConsoleLink(orderId, stage, version)
      : createRoyaltyTraceLink(orderId, stage);

  return (
    <Link
      external
      externalIconAriaLabel="Opens in a new tab"
      href={href}
      data-testid="sourcelink"
    >
      {normalizedSource}
    </Link>
  );
}

DigitalOrderSourceLink.defaultProps = {
  source: DEFAULT_SOURCE,
};
